import { ref } from "vue";
import api from "../api/axios";
import router from "@/router";

const user = ref(null);
const loading = ref(true);
let initialized = false;

// 🔄 Cargar usuario UNA sola vez
// (reintenta si el usuario en memoria está incompleto, ej. sin "name" tras el login)
// force=true ignora el caché en memoria y siempre vuelve a pedir /me -- útil
// en vistas que dependen de un campo agregado recientemente (ej.
// companySlug), donde un usuario ya "initialized" desde antes de ese cambio
// (misma pestaña, sin recargar) se quedaría con el objeto viejo para
// siempre si no se fuerza el refetch.
const loadUser = async (force = false) => {
  if (!force && initialized && user.value?.name) return;

  initialized = true;

  const token = localStorage.getItem("accessToken");

  if (!token) {
    loading.value = false;
    return;
  }

  try {
    const res = await api.get("/me");
    user.value = res.data.user;
  } catch (err) {
    console.log("❌ Token inválido o expirado");
    
    user.value = null;
    localStorage.clear();

    // 🔥 REDIRECCIÓN
    router.push({ name: "/" }); // o "login"
  } finally {
    loading.value = false;
  }
};

// 🔐 LOGIN
const login = async (email, password) => {
  try {
    const res = await api.post("/login", { email, password });

    const { accessToken, refreshToken, user: userData } = res.data;

    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);

    user.value = userData;

    return userData;
  } catch (err) {
    console.error("LOGIN ERROR:", err.response?.data);
    throw err;
  }
};

// 🚪 LOGOUT
const logout = async () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");

    if (refreshToken) {
      await api.post("/logout", { refreshToken });
    }
  } catch (err) {
    console.error("Logout error:", err);
  }

  localStorage.clear();
  user.value = null;
};

// 🛡️ Permisos
const hasPermission = (permission) => {
  if (!user.value) return false;
  return user.value.permissions?.includes(permission);
};

// 🛡️ Roles
const hasRole = (role) => {
  if (!user.value) return false;
  return user.value.role === role;
};

export function useAuth() {
  return {
    user,
    loading,
    loadUser,
    login,
    logout,
    hasPermission,
    hasRole,
  };
}